import HTMLColumnsStrategy from '../HTMLColumnsStrategy'

export default function StaffPerformanceHTMLPreviewBaseColumnsStrategy() {}

StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype = new HTMLColumnsStrategy();

StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype.init = function( timeFormat, groupNameProvider)
{
    HTMLColumnsStrategy.prototype.init.call( this, timeFormat );
    this.groupNameProvider = groupNameProvider;
    return this;
};

StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype.addFirstHeaderRowCells = function( firstHeaderRow )
{
    // abstract
};

StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype.addSecondHeaderRowCells = function( secondHeaderRow )
{
    // abstract
};

StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype.addDataCells = function( row )
{
    this.addTimeValueCell(row, "spent");
    this.addTimeValueCell(row);
    this.addTimeValueCell(row);
};

StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype.createUserHeaderCell = function( rowSpan )
{
    return ReportPreviewUtils.createCell( this.message("report.common.user"), "user", 1, rowSpan );
};

StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype.createSpentHeaderCell = function ()
{
    return ReportPreviewUtils.createCell( this.message("report.staffoutput.overall_spent"), "spent", 1, 2 );
};

StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype.getGroupNameSingular = function ()
{
    return this.message(this.groupNameProvider.getGroupNameSingularKey());
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/staffperformance/StaffPerformanceHTMLPreviewBaseColumnsStrategy.js